import { render, staticRenderFns } from "./contractCreateFeeList.vue?vue&type=template&id=62b88d92&scoped=true"
import script from "./contractCreateFeeList.vue?vue&type=script&lang=js"
export * from "./contractCreateFeeList.vue?vue&type=script&lang=js"
import style0 from "./contractCreateFeeList.vue?vue&type=style&index=0&id=62b88d92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b88d92",
  null
  
)

export default component.exports